var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-error"},[_c('h1',[_vm._v("页面找不到了！")]),_c('p',[_vm._v(" 你的路由地址可能配错了,具体错误请查看控制台 "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.replace('/')}}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }